export const editorInit = (quill: any) => {
  quill.clipboard.addMatcher(Node.ELEMENT_NODE, (node: Node, delta: any) => {
    delta.forEach((op: any) => {
      if (op.attributes) {
        op.attributes.color = '';
        op.attributes.background = '';
      }
    });
    return delta;
  });
};
